import ScalarIconGlobe_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGlobe.vue.script.js";
//#region src/components/ScalarIconGlobe.vue
var ScalarIconGlobe_default = ScalarIconGlobe_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGlobe_default as default };

//# sourceMappingURL=ScalarIconGlobe.js.map